// extracted by mini-css-extract-plugin
module.exports = {"Title":"style_Title__3lSHb","Text":"style_Text__3F-yK","Divider":"style_Divider__l7vDN","Phone":"style_Phone__31x2d","Mail":"style_Mail__3LDYJ","Button":"style_Button__1Ta2X"};